// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/activity/media_consent.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/activity/media_consent.proto.
 */
export const file_proto_model_booking_activity_media_consent = /*@__PURE__*/
  fileDesc("CjBwcm90by9tb2RlbC9ib29raW5nL2FjdGl2aXR5L21lZGlhX2NvbnNlbnQucHJvdG8SBmNhcm1lbiL4BwoMTWVkaWFDb25zZW50EhsKE3Bob3RvX2NvbnNlbnRfZ2l2ZW4YASABKAgSGwoTdmlkZW9fY29uc2VudF9naXZlbhgCIAEoCBIiChpzb2NpYWxfbWVkaWFfY29uc2VudF9naXZlbhgDIAEoCBIfChdtYXJrZXRpbmdfY29uc2VudF9naXZlbhgEIAEoCBJGChJ1c2FnZV9yZXN0cmljdGlvbnMYBSADKA4yKi5jYXJtZW4uTWVkaWFDb25zZW50Lk1lZGlhVXNhZ2VSZXN0cmljdGlvbhJLChRkZWxpdmVyeV9wcmVmZXJlbmNlcxgGIAEoCzItLmNhcm1lbi5NZWRpYUNvbnNlbnQuTWVkaWFEZWxpdmVyeVByZWZlcmVuY2VzGrkDChhNZWRpYURlbGl2ZXJ5UHJlZmVyZW5jZXMSHgoWd2FudHNfcGhvdG9zX2RlbGl2ZXJlZBgBIAEoCBIeChZ3YW50c192aWRlb3NfZGVsaXZlcmVkGAIgASgIEhYKDmRlbGl2ZXJ5X2VtYWlsGAMgASgJElsKEHByZWZlcnJlZF9mb3JtYXQYBCABKA4yQS5jYXJtZW4uTWVkaWFDb25zZW50Lk1lZGlhRGVsaXZlcnlQcmVmZXJlbmNlcy5NZWRpYURlbGl2ZXJ5Rm9ybWF0IucBChNNZWRpYURlbGl2ZXJ5Rm9ybWF0EiUKIU1FRElBX0RFTElWRVJZX0ZPUk1BVF9VTlNQRUNJRklFRBAAEioKJk1FRElBX0RFTElWRVJZX0ZPUk1BVF9ESUdJVEFMX0RPV05MT0FEEAESJwojTUVESUFfREVMSVZFUllfRk9STUFUX0NMT1VEX1NUT1JBR0UQAhIoCiRNRURJQV9ERUxJVkVSWV9GT1JNQVRfUEhZU0lDQUxfTUVESUEQAxIqCiZNRURJQV9ERUxJVkVSWV9GT1JNQVRfU09DSUFMX01FRElBX1RBRxAEIpcCChVNZWRpYVVzYWdlUmVzdHJpY3Rpb24SJwojTUVESUFfVVNBR0VfUkVTVFJJQ1RJT05fVU5TUEVDSUZJRUQQABIjCh9NRURJQV9VU0FHRV9SRVNUUklDVElPTl9OT19GQUNFEAESJwojTUVESUFfVVNBR0VfUkVTVFJJQ1RJT05fTk9fQ0hJTERSRU4QAhIrCidNRURJQV9VU0FHRV9SRVNUUklDVElPTl9OT19TT0NJQUxfTUVESUEQAxItCilNRURJQV9VU0FHRV9SRVNUUklDVElPTl9OT19DT01NRVJDSUFMX1VTRRAEEisKJ01FRElBX1VTQUdFX1JFU1RSSUNUSU9OX0NSRURJVF9SRVFVSVJFRBAFQjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw");

/**
 * Describes the message carmen.MediaConsent.
 * Use `create(MediaConsentSchema)` to create a new message.
 */
export const MediaConsentSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_media_consent, 0);

/**
 * Describes the message carmen.MediaConsent.MediaDeliveryPreferences.
 * Use `create(MediaConsent_MediaDeliveryPreferencesSchema)` to create a new message.
 */
export const MediaConsent_MediaDeliveryPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_media_consent, 0, 0);

/**
 * Describes the enum carmen.MediaConsent.MediaDeliveryPreferences.MediaDeliveryFormat.
 */
export const MediaConsent_MediaDeliveryPreferences_MediaDeliveryFormatSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_media_consent, 0, 0, 0);

/**
 * @generated from enum carmen.MediaConsent.MediaDeliveryPreferences.MediaDeliveryFormat
 */
export const MediaConsent_MediaDeliveryPreferences_MediaDeliveryFormat = /*@__PURE__*/
  tsEnum(MediaConsent_MediaDeliveryPreferences_MediaDeliveryFormatSchema);

/**
 * Describes the enum carmen.MediaConsent.MediaUsageRestriction.
 */
export const MediaConsent_MediaUsageRestrictionSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_media_consent, 0, 0);

/**
 * @generated from enum carmen.MediaConsent.MediaUsageRestriction
 */
export const MediaConsent_MediaUsageRestriction = /*@__PURE__*/
  tsEnum(MediaConsent_MediaUsageRestrictionSchema);

